<template>
   <div>
       <label v-if="label"
            :for="id ? id : name"
       >{{label}}</label>
       <select class="selectpicker" ref="select"
            :name="name"
            :class="[validation ? 'is-invalid' : '', customclass]"
            :id="id ? id : name"
            v-model="value"
            @change="changeSelect($event)"
        >
            <option v-for="(el, key) in options" :key="key"
                :value="el.value"
            >{{el.text}}</option>
        </select>
   </div>
</template>

<script>

export default {

    props: ['title', 'options', 'styleSelect', 'selected', 'label', 'id', 'name', 'customclass', 'invalid'],

    data(){
        return {
            value: this.$props.selected,
            validation: null,
        }
    },
    mounted(){
        $(this.$refs.select).selectpicker({
            style: this.$props.styleSelect,
            title: this.$props.title,
        });
    },
    updated() {
        $(this.$refs.select).selectpicker('refresh');
    },
    methods: {
        changeSelect(ev) {
            this.$emit('select-change-event', ev);
            this.validation = null;
        }
    },
    watch: {
        invalid(val){
            this.validation  = val;
        }
    }
}
</script>
